module.exports = __webpack_public_path__ + "static/media/logoTradeHall.86086229.svg";